import React from "react";
import { Table } from "react-bootstrap";

interface StorageViewerProps {
  title?: string;
  icon?: string;
  data: Record<string, string | null>;
}

const StorageViewer: React.FC<StorageViewerProps> = ({
  title,
  icon = "",
  data,
}) => {
  return (
    <Table striped bordered hover responsive size="sm">
      <thead>
        <tr>
          <th>Key</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(data).map(([key, value]) => (
          <tr key={key}>
            <td style={{ fontWeight: "bold", fontFamily: "monospace" }}>{key}</td>
            <td
              style={{
                maxWidth: "300px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontFamily: "monospace",
                fontSize: "12px"
              }}
              title={value || ""}
            >
              {value}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default StorageViewer;